var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { create } from 'zustand';
export var CurrentTabEnum;
(function (CurrentTabEnum) {
    CurrentTabEnum[CurrentTabEnum["POLICY"] = 1] = "POLICY";
    CurrentTabEnum[CurrentTabEnum["CLAIMS"] = 2] = "CLAIMS";
    CurrentTabEnum[CurrentTabEnum["NOTIFICATIONS"] = 3] = "NOTIFICATIONS";
    CurrentTabEnum[CurrentTabEnum["QUOTE_INFO"] = 4] = "QUOTE_INFO";
    CurrentTabEnum[CurrentTabEnum["POLICY_INFO"] = 5] = "POLICY_INFO";
    CurrentTabEnum[CurrentTabEnum["COVERAGES"] = 6] = "COVERAGES";
    CurrentTabEnum[CurrentTabEnum["POLICY_INFO_LAST_STEP"] = 7] = "POLICY_INFO_LAST_STEP";
    CurrentTabEnum[CurrentTabEnum["QUOTE_PENDING"] = 8] = "QUOTE_PENDING";
    CurrentTabEnum[CurrentTabEnum["POLICY_CHANGES"] = 9] = "POLICY_CHANGES";
    CurrentTabEnum[CurrentTabEnum["VIEW_POLICY_CHANGES"] = 10] = "VIEW_POLICY_CHANGES";
    CurrentTabEnum[CurrentTabEnum["BUSINESS_TYPE_SELECTION"] = 11] = "BUSINESS_TYPE_SELECTION";
    CurrentTabEnum[CurrentTabEnum["RECOMMENDED_POLICIES"] = 12] = "RECOMMENDED_POLICIES";
    CurrentTabEnum[CurrentTabEnum["POLICY_DOCUMENTS"] = 13] = "POLICY_DOCUMENTS";
    CurrentTabEnum[CurrentTabEnum["ELIGIBILITY_ENGINE"] = 14] = "ELIGIBILITY_ENGINE";
    CurrentTabEnum[CurrentTabEnum["ELIGIBLE_POLICIES"] = 15] = "ELIGIBLE_POLICIES";
    CurrentTabEnum[CurrentTabEnum["POLICY_AUDIT_AI_RECOMMENDED_POLICIES"] = 16] = "POLICY_AUDIT_AI_RECOMMENDED_POLICIES";
})(CurrentTabEnum || (CurrentTabEnum = {}));
var initialState = {
    selectedQuote: null,
    selectedPolicy: null,
    currentTab: CurrentTabEnum.POLICY,
    showNotification: false,
    isFormActive: false,
    modalOpen: false,
    answers: null,
    applicationDataId: null,
    notificationSwitched: false,
    createQuoteSubmitted: false,
    selectedBusinessTypeOptions: [],
    recommendedPolicies: [],
    activeDraftQuote: null,
    currQuestionGroup: 0,
    isEditRequested: false,
    eligibilityEngineAnswers: null,
    selectedPolicyPayload: null,
    policyPaymentPayloads: null,
    unifiedState: {},
    footerOverride: null
};
var useWidgetStore = create(function (set) { return (__assign(__assign({}, initialState), { resetState: function () { return set(__assign({}, initialState)); }, setIsEditRequested: function (val) {
        set(function () { return ({
            isEditRequested: val
        }); });
    }, setCurrQuestionGroup: function (val) {
        set(function () { return ({
            currQuestionGroup: val
        }); });
    }, setEligibilityEngineAnswers: function (val) {
        set(function () { return ({
            eligibilityEngineAnswers: val
        }); });
    }, setPolicyPaymentPayloads: function (val) {
        set(function () { return ({
            policyPaymentPayloads: val
        }); });
    }, setSelectedPolicyPayload: function (val) {
        set(function () { return ({
            selectedPolicyPayload: val
        }); });
    }, setActiveDraftQuote: function (val) {
        set(function (state) { return ({
            activeDraftQuote: typeof val === 'function' ? val(state.activeDraftQuote) : val
        }); });
    }, setSelectedQuote: function (val) {
        set(function () { return ({
            selectedQuote: val
        }); });
    }, setNotificationSwitched: function (notificationTab) {
        set(function (state) { return ({
            notificationSwitched: notificationTab
        }); });
    }, setApplicationDataId: function (applicationDataRef) {
        set(function (state) { return ({
            applicationDataId: applicationDataRef
        }); });
    }, setAnswers: function (ans) {
        set(function (state) { return ({
            answers: ans
        }); });
    }, setSelectedPolicy: function (_a) {
        var policyId = _a.policyId, externalId = _a.externalId;
        set(function (state) { return ({
            selectedPolicy: {
                policyId: policyId,
                externalId: externalId
            }
        }); });
    }, setFormActive: function (isFormActive) {
        set(function (state) { return ({
            isFormActive: isFormActive
        }); });
    }, resetWidgetState: function () {
        set(function (state) { return ({
            currentTab: CurrentTabEnum.POLICY,
            showNotification: false
        }); });
    }, setCurrentTab: function (tab) {
        set(function (state) { return ({
            currentTab: tab
        }); });
    }, setShowNotification: function (notif) {
        set(function (state) { return ({
            showNotification: notif
        }); });
    }, setModalOpen: function (open) {
        set(function (state) {
            var newVals = {
                modalOpen: open
            };
            if (!open) {
                newVals = __assign(__assign({}, newVals), { selectedQuote: null, selectedPolicy: null, currentTab: CurrentTabEnum.POLICY, showNotification: false, isFormActive: false, answers: null, applicationDataId: null, notificationSwitched: false, createQuoteSubmitted: false, selectedBusinessTypeOptions: [], recommendedPolicies: [], activeDraftQuote: null, currQuestionGroup: 0, isEditRequested: false, selectedPolicyPayload: null });
            }
            return newVals;
        });
    }, toggleModal: function () {
        set(function (state) {
            var open = !state.modalOpen;
            var newVals = {
                modalOpen: open
            };
            if (!open) {
                newVals = __assign(__assign({}, newVals), { selectedQuote: null, selectedPolicy: null, currentTab: CurrentTabEnum.POLICY, showNotification: false, isFormActive: false, answers: null, applicationDataId: null, notificationSwitched: false, createQuoteSubmitted: false, selectedBusinessTypeOptions: [], recommendedPolicies: [], activeDraftQuote: null, currQuestionGroup: 0, isEditRequested: false, selectedPolicyPayload: null });
            }
            return newVals;
        });
    }, setCreateQuoteSubmitted: function (val) {
        set(function () { return ({
            createQuoteSubmitted: val
        }); });
    }, setBusinessTypeSelectedOptions: function (id) {
        set(function (state) {
            var isSelected = state.selectedBusinessTypeOptions.includes(id);
            return {
                selectedBusinessTypeOptions: isSelected
                    ? state.selectedBusinessTypeOptions.filter(function (option) { return option !== id; })
                    : __spreadArray(__spreadArray([], state.selectedBusinessTypeOptions, true), [id], false)
            };
        });
    }, setRecommendedPolicies: function (ids) {
        set({ recommendedPolicies: __spreadArray([], ids, true) });
    }, setUnifiedState: function (obj) {
        set(function (state) {
            if (typeof obj === 'function') {
                return { unifiedState: obj(state.unifiedState) };
            }
            return { unifiedState: obj };
        });
    }, setFooterOverride: function (value) {
        set(function (state) { return ({
            footerOverride: value
        }); });
    } })); });
export default useWidgetStore;
